import { render, staticRenderFns } from "./Description_mobile.vue?vue&type=template&id=324840d6&scoped=true&"
import script from "./Description_mobile.vue?vue&type=script&lang=js&"
export * from "./Description_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Description_mobile.vue?vue&type=style&index=0&id=324840d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324840d6",
  null
  
)

export default component.exports